export default __webpack_public_path__ + "static/media/feature-compliance-2.9c9a59da.png";